var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreatIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.629 35.066L34.0032 31.4402C34.6507 30.4043 35.0392 29.1094 35.0392 27.8145C35.0392 24.1887 32.1904 21.3398 28.5646 21.3398C24.9388 21.3398 22.09 24.1887 22.09 27.8145C22.09 31.4402 24.9388 34.2891 28.5646 34.2891C29.8595 34.2891 31.1544 33.9006 32.1904 33.2531L35.8161 36.8789L37.629 35.066ZM24.6798 27.8145C24.6798 25.6131 26.3632 23.9297 28.5646 23.9297C30.7659 23.9297 32.4493 25.6131 32.4493 27.8145C32.4493 30.0158 30.7659 31.6992 28.5646 31.6992C26.3632 31.6992 24.6798 30.0158 24.6798 27.8145ZM9.14075 18.75H22.09V21.3398H9.14075V18.75ZM9.14075 10.9805H24.6798V13.5703H9.14075V10.9805Z",
    fill: "#FF5B37",
    stroke: "#FAEEF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9103 33.9006L10.1767 30.2748C6.29192 28.3324 3.96106 24.3182 3.96106 20.0449V3.21094H29.8595V17.4551H32.4493V3.21094C32.4493 1.78652 31.2839 0.621094 29.8595 0.621094H3.96106C2.53665 0.621094 1.37122 1.78652 1.37122 3.21094V20.0449C1.37122 25.3541 4.22004 30.1453 8.88176 32.6057L16.9103 36.8789V33.9006Z",
    fill: "#FF5B37",
    stroke: "#FAEEF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreatIcon03);
export default __webpack_public_path__ + "static/media/great-icon-03.482c5f93de22ed68d367f3bbbdab9532.svg";
export { ForwardRef as ReactComponent };